import axios from 'axios';
import { baseUrl } from '../../hooks/useEndpoints';

/**
 * Endpoint drill-down "Sforzo" atleta (spec 2026-07-26-tab-sforzo-design.md).
 * File separato da useEndpoints per evitare conflitti col lavoro parallelo
 * sulla vista team (TeamEffortTab).
 */

export interface IEffortAthleteKpi {
  /** Carico settimana corrente in AU (somma sRPE lun→oggi) */
  weekLoad: number;
  /** Δ% vs settimana precedente — null se settimana precedente = 0 */
  deltaPct: number | null;
  /** Monotonia settimanale (media/SD sRPE giornalieri 7gg) */
  monotony: number | null;
  /** Strain = carico settimanale totale × monotonia */
  strain: number;
  /** ACWR (acute 7gg / chronic 28gg, stesso metodo getRpe) */
  acwr: number | null;
  /** true se ACWR fuori fascia 0.80–1.30 */
  outOfRange: boolean;
}

export interface IEffortSeriesPoint {
  /** YYYY-MM-DD */
  date: string;
  /** sRPE giornaliero (AU) */
  srpe: number;
  /** Carico acuto — EWMA 7 giorni */
  acuteEwma: number;
  /** Carico cronico — EWMA 28 giorni */
  chronicEwma: number;
  acwr: number | null;
}

export interface IEffortAthleteResponse {
  /** Anagrafica opzionale restituita dal BE (fallback per l'header) */
  athlete?: {
    _id?: string;
    firstName?: string;
    lastName?: string;
    role?: string;
  };
  kpi: IEffortAthleteKpi;
  series: IEffortSeriesPoint[];
}

export const effortAthleteEndpoints = {
  /** GET /effort/athlete/:athleteId?teamId=&days=28 */
  getAthleteEffort: (athleteId: string, params: { teamId?: string; days?: number }) =>
    axios.get<IEffortAthleteResponse>(`${baseUrl}/effort/athlete/${athleteId}`, { params }),
};
